import React from 'react';
import {
    Modal,
    Box,
    Typography,
    TextField,
    Button,
    Select,
    FormControl,
    InputLabel,
    MenuItem
} from '@mui/material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const PayoutModal = ({
    open,
    payoutAmount,
    handleClose,
    submitRequest,
    reference_id,
    setReference_id,
    statusPaid,
    setStatusPaid,
    payment_date,
    paymentDateDataHandler,
    paymentMethod,
    setPaymentMethod,
    comment,
    setComment,
    setPayment_date,
    readOnly = false,
}) => {
    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 600,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2
                }}
            >
                <Typography variant="h6" gutterBottom>
                    Requested Amount
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                    <CurrencyRupeeIcon fontSize="large" />
                    {payoutAmount?.amount_paid}
                </Typography>

                <Box display="flex" gap={2} mt={2}>
                    <FormControl fullWidth>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Payment Date *"
                                value={payment_date}
                                disabled={readOnly}
                                // onChange={paymentDateDataHandler}
                                onChange={(date) => setPayment_date(date, 'payment_date')}
                                renderInput={(params) => (
                                    <TextField
                                        size="small"
                                        sx={{ backgroundColor: '#F6F6F6' }}
                                        {...params}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </FormControl>
                    <TextField
                        label="Reference Id"
                        type="text"
                        fullWidth
                        value={reference_id}
                        onChange={(e) => setReference_id(e.target.value)}
                        disabled={readOnly}
                    />
                </Box>

                <Box display="flex" gap={2} mt={2}>
                    {[
                        {
                            value: paymentMethod,
                            changeValue: setPaymentMethod,
                            label: 'Payment Method *',
                            options: ['Bank Transfer', 'UPI'],
                        },
                        {
                            value: statusPaid,
                            changeValue: setStatusPaid,
                            label: 'Status *',
                            options: ['Paid', 'On-Hold'],
                        },
                    ].map((item, idx) => {
                        const labelId = `select-label-${idx}`;
                        return (
                            <FormControl fullWidth key={idx} disabled={readOnly}>
                                <InputLabel id={labelId}>{item.label}</InputLabel>
                                <Select
                                    labelId={labelId}
                                    id={`select-${idx}`}
                                    value={item.value}
                                    label={item.label}
                                    onChange={(e) => item.changeValue(e.target.value)}
                                    disabled={readOnly}
                                >
                                    {item.options.map((opt, i) => (
                                        <MenuItem key={i} value={opt}>
                                            {opt}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        );
                    })}
                </Box>

                <TextField
                    label="Comment"
                    type="text"
                    fullWidth
                    value={comment || ''}
                    onChange={(e) => setComment(e.target.value)}
                    sx={{ my: 2 }}
                    disabled={readOnly || statusPaid !== "On-Hold"}
                />

                <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                    <Button variant="text" className="gn-actionbtn-color" onClick={handleClose}>
                        {readOnly ? 'Close' : 'Cancel'}
                    </Button>
                    {!readOnly && (
                        <Button variant="contained" className="gn-actionbtn"
                            disabled={!payment_date || !statusPaid || !paymentMethod}
                            onClick={submitRequest}>
                            Pay
                        </Button>
                    )}
                </Box>
            </Box>
        </Modal>
    );
};

export default PayoutModal;
